import React, { FC } from 'react';
import { TransportInfo, TransportStatus } from '../../types';
import ProgressStatusIcon from '@lmt/unicorn-shared/app/icons/transporter/transport-progress.svg?react';
import SuccessStatusIcon from '@lmt/unicorn-shared/app/icons/transporter/transport-success.svg?react';
import ErrorStatusIcon from '@lmt/unicorn-shared/app/icons/transporter/transport-error.svg?react';
import { AppTooltip } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppTooltip';
import styles from './TransportStatusOption.module.scss';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { getFormattedDateTime } from '../../../../common';

export const TransportStatusOption: FC<TransportInfo> = (props) => {
  const { isGDT, isHL7 } = props;

  const i18n = useScopedTranslation('patients.cases.transport');
  const status =
    isGDT && isHL7
      ? props.gdtStatus === TransportStatus.error ||
        props.hl7Status === TransportStatus.error
        ? TransportStatus.error
        : props.gdtStatus === TransportStatus.progress ||
            props.hl7Status === TransportStatus.progress
          ? TransportStatus.progress
          : TransportStatus.success
      : isGDT
        ? props.gdtStatus
        : isHL7
          ? props.hl7Status
          : TransportStatus.error;
  return (
    <div className={styles.container} data-test-id="paper-plane-icon">
      <AppTooltip
        arrow={true}
        title={
          <div className={styles.tooltip}>
            {isHL7 && (
              <>
                <div className={styles.title}>
                  HL7: {i18n.t(`status.${props.hl7Status}` as any)}
                </div>
                <div className={styles.text}>
                  {i18n.t('sent_date', {
                    date: getFormattedDateTime(props.hl7Date),
                  })}
                </div>
              </>
            )}
            {isGDT && (
              <>
                <div className={styles.title}>
                  GDT: {i18n.t(`status.${props.gdtStatus}` as any)}
                </div>
                <div className={styles.text}>
                  {i18n.t('sent_date', {
                    date: getFormattedDateTime(props.gdtDate),
                  })}
                </div>
              </>
            )}
          </div>
        }
      >
        {status === TransportStatus.progress ? (
          <ProgressStatusIcon />
        ) : status === TransportStatus.success ? (
          <SuccessStatusIcon />
        ) : status === TransportStatus.error ? (
          <ErrorStatusIcon />
        ) : (
          <></>
        )}
      </AppTooltip>
    </div>
  );
};
